module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "recently-added"
  }, [_c('h2', [_vm._v("Recently Added")]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("Parametric PCR")]), _vm._v(" "), _c('p', [_vm._v("Author "), _c('a', [_vm._v("Opentrons")])]), _vm._v(" "), _c('p', [_vm._v("Ut sollicitudin viverra volutpat. Pellentesque aliquam hendrerit tempor. Sed ut leo interdum, porttitor nunc a.")]), _vm._v(" "), _c('a', {
    staticClass: "view-protocol"
  }, [_vm._v("View Protocol")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-61c46034!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecentlyAdded.vue
// module id = 241
// module chunks = 2